/**
 * taskflow-shortcuts.ts
 *
 * Global Keyboard Shortcuts Manager for TaskFlow Workspace.
 * Suppresses hotkeys when typing in form inputs and maps navigation / command keys.
 */

export type ShortcutCommand =
  | 'SWITCH_VIEW_BOARD'
  | 'SWITCH_VIEW_CALENDAR'
  | 'SWITCH_VIEW_TIMELINE'
  | 'SWITCH_VIEW_WBS'
  | 'SWITCH_VIEW_TRIAGE'
  | 'CREATE_NEW_TASK'
  | 'FOCUS_SEARCH_FILTER'
  | 'OPEN_COMMAND_PALETTE'
  | 'OPEN_HELP_MODAL'
  | 'UNKNOWN';

export interface KeyTargetLike {
  tagName?: string;
  isContentEditable?: boolean;
}

export class TaskFlowShortcutManager {
  /**
   * Check if keyboard event originated from a form field and should be ignored
   */
  static shouldIgnoreEvent(target: KeyTargetLike | null | undefined): boolean {
    if (!target) return false;

    const tag = (target.tagName || '').toUpperCase();
    if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') {
      return true;
    }

    if (target.isContentEditable) {
      return true;
    }

    return false;
  }

  /**
   * Resolve key stroke into a canonical TaskFlow command
   */
  static resolveKey(
    key: string,
    metaOrCtrl: boolean,
    shiftKey: boolean
  ): ShortcutCommand {
    const k = key.toLowerCase();

    if (metaOrCtrl) {
      if (k === 'k') return 'OPEN_COMMAND_PALETTE';
      if (k === '/' || k === '?') return 'OPEN_HELP_MODAL';
      return 'UNKNOWN';
    }

    if (k === 'b') return 'SWITCH_VIEW_BOARD';
    if (k === 'c') return 'SWITCH_VIEW_CALENDAR';
    if (k === 't') return 'SWITCH_VIEW_TIMELINE';
    if (k === 'w') return 'SWITCH_VIEW_WBS';
    if (k === 'q') return 'SWITCH_VIEW_TRIAGE';
    if (k === 'n') return 'CREATE_NEW_TASK';
    if (k === 'f') return 'FOCUS_SEARCH_FILTER';
    if (k === '?' || (shiftKey && k === '/')) return 'OPEN_HELP_MODAL';

    return 'UNKNOWN';
  }
}
